import { Pipe, PipeTransform } from "@angular/core";

// Takes a date string like '03-16-2022' and returns '03/16/2022'
@Pipe({ name: 'formattedDate', standalone: false })
export class FormatDatePipe implements PipeTransform {
    transform(dateString: string): string {
        if (!dateString) return '';
        let dateArray = dateString.includes('-') ?
            dateString.split('-') :
            dateString.split('/');
        dateArray.forEach((item, idx) => {
            if (item.length === 4 && idx == 0) dateArray.push(dateArray.shift() ?? '');
            if (item.length == 1) dateArray[idx] = `0${item}`;
        });
        return dateArray.join('/');
    }
}